import { cn } from "@/lib/utils";
import { useMicLevels } from "./use-mic-levels";

/**
 * Bars that move with the voice while recording (newest on the right, so the
 * wave scrolls left as you speak). Pass the MediaStream of the recording;
 * `paused` freezes and greys the bars.
 *
 * `<LiveWaveform stream={recorder.stream} paused={recorder.isPaused} />`
 */
export function LiveWaveform({ stream, paused = false, bars = 48, className }: { stream: MediaStream | null; paused?: boolean; bars?: number; className?: string }) {
  const levels = useMicLevels(paused ? null : stream, bars);
  return (
    <div className={cn("flex h-11 items-center justify-center gap-[3px]", className)} aria-hidden="true">
      {levels.map((level, i) => (
        <span
          key={i}
          className={cn("w-[3px] shrink-0 rounded-full transition-[height] duration-75", !paused && level > 0.04 ? "bg-primary" : "bg-foreground/20")}
          style={{ height: Math.max(4, 6 + level * 38) }}
        />
      ))}
    </div>
  );
}
